var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('module',[(_vm.auth('b_refund_info_detail'))?_c('refund-list',{attrs:{"state":_vm.state}}):_vm._e(),(_vm.auth('b_return_info_detail'))?_c('return-list',{attrs:{"return_state":_vm.return_state}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }